import { lazy } from "react";
import { Navigate } from "react-router";
import { FeatureFlagRoute } from "../../_features/featureFlags/routing/FeatureFlagRoute";
import { isJsonViewerEnabled } from "./utils/isJsonViewerEnabled";
import { isComponentLibraryEnabled } from "./utils/isComponentLibraryEnabled";
import { paths } from "./paths";

const JsonDataViewer = lazy(() => import("./JsonDataViewer"));
const ComponentLibraryPage = lazy(() => import("../../_features/componentLibrary/pages/ComponentLibraryPage"));
const ComponentInsiderPage = lazy(() => import("../../_features/componentLibrary/pages/ComponentInsiderPage"));
const RevenuePage = lazy(() => import("../../_features/revenue/pages/RevenuePage"));
const SetupPage = lazy(() => import("../../_features/setup/pages/SetupPage"));

// Public routes - rendered outside PrivateRoute/AppLayout
export const miscRoutes = [
    { path: paths.home, element: <Navigate to={paths.company} /> },
];

// Private routes - rendered inside PrivateRoute + AppLayout (see app.routes.jsx)
export const miscPrivateRoutes = [
    ...(isJsonViewerEnabled() ? [{
        path: "/json-viewer",
        element: (
            <FeatureFlagRoute feature="jsonViewer">
                <JsonDataViewer />
            </FeatureFlagRoute>
        )
    }] : []),
    // Dev-only living catalogue of the shared _components/ui library - same
    // host/env gate as JsonDataViewer above, no separate feature flag (it's
    // a build-time reference doc, not an org-configurable feature).
    ...(isComponentLibraryEnabled() ? [{
        path: "/component-library",
        element: <ComponentLibraryPage />
    }, {
        // Per-component "insider view" - explanation + props table + a live
        // playground, drilled into from a component's own section on the
        // catalogue page above. Same gate as its parent (no separate check
        // needed - this route only exists nested under an already-gated one).
        path: "/component-library/:componentId",
        element: <ComponentInsiderPage />
    }] : []),
    // Static placeholder - see docs/sidenav-design-parity-tasks.md
    { path: paths.revenue, element: <RevenuePage /> },
    // Moved out of the settings layout - the design puts Setup under the
    // main dashboard nav, not the settings sidenav.
    { path: paths.setup, element: <SetupPage /> },
];
